exports = module.exports = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-495b6122] .el-input-number .el-input__inner{text-align:left}", ""]);

// exports
